import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

export const HubixPlatformPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: '{teal.50}',
            100: '{teal.100}',
            200: '{teal.200}',
            300: '{teal.300}',
            400: '{teal.400}',
            500: '{teal.500}',
            600: '{teal.600}',
            700: '{teal.700}',
            800: '{teal.800}',
            900: '{teal.900}',
            950: '{teal.950}'
        }
    },
    components: {
        // button: {
        //     padding: {
        //         x: '.75rem',
        //         y: '.25rem'
        //     }
        // },
        card: {
            colorScheme: {
                light: {
                    root: {
                        background: '{surface.0}',
                        color: '{surface.700}'
                    },
                    subtitle: {
                        color: '{surface.500}'
                    }
                }
            }
        },
        // inputtext: {
        //     padding: {
        //         x: '.75rem',
        //         y: '.35rem'
        //     }
        // }
    }
});
